// Builds the options for the "Form Email Fields" recipient dropdowns on the program email tabs.
// Only reads the program's request form; never mutates it.
// Values are the form field `id`, which is the same key the submission's formData is written under.
//
// A field qualifies when it can hold email addresses:
//  - an Email field (including the base Email field), or
//  - a Text / Text Area field, since requesters may type several addresses separated by commas.
// The API keeps only valid addresses from each value, so a text field with other content is harmless.
// Base text fields (Name, etc.) are skipped. Additional attendee emails (nested in moduleConfiguration) and
// the notifierEmail module field are not submitted email values, so they are intentionally left out.
const isEmailField = (field) => !!field && !!field.id && (field.type === 'email' || field.id === 'email');

const isFreeTextField = (field) =>
	!!field && !!field.id && (field.type === 'text' || field.type === 'textarea') && field.objectClass !== 'baseInput';

const getEmailFieldOptions = (program) => {
	const options = [];
	const seen = {};
	const addField = (field) => {
		if (!field || !field.id || seen[field.id]) {
			return;
		}
		if (isEmailField(field)) {
			seen[field.id] = true;
			options.push({ value: field.id, label: field.label || field.id });
		} else if (isFreeTextField(field)) {
			seen[field.id] = true;
			options.push({ value: field.id, label: field.label || field.id });
		}
	};

	const requestForm = program && program.requestForm;
	if (!requestForm) {
		return options;
	}

	const sections = requestForm.pages
		? requestForm.pages.reduce((all, page) => all.concat(page.sections || []), [])
		: requestForm.sections || [];

	sections.forEach((section) => {
		(section.fields || []).forEach((field) => {
			addField(field);
			(field.nestedSections || []).forEach((nestedSection) => {
				(nestedSection.questions || []).forEach(addField);
			});
		});
	});

	return options;
};

export default getEmailFieldOptions;
